module.exports = __webpack_public_path__ + "static/iokharic_script_alphabet_DND4_DCD-766db6bc14d470fe93f1427ffed187eb.png";